(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royse-catalogos"] && !Shopify.designMode) return;
  try {
    

function initRoyseCatalogs(scope=document){
 scope.querySelectorAll('.royse-catalogos').forEach(root=>{
  if(root.dataset.enhanced==='true')return;
  const searchBox=root.querySelector('.royse-catalogos__search');
  const searchInput=searchBox?.querySelector('input');
  if(searchInput){
   searchBox.hidden=false;
   const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
   const cards=Array.from(root.querySelectorAll('[data-catalog-search]'));
   const brands=Array.from(root.querySelectorAll('.royse-catalogos__brand'));
   const panels=new Map(brands.map(brand=>[brand,brand.querySelector('.royse-catalogos__panel')]));
   const actions=new Map(brands.map(brand=>[brand,brand.querySelector('.royse-catalogos__action').innerHTML]));
   searchInput.addEventListener('input',()=>{
    const words=normalize(searchInput.value).trim().split(/\s+/).filter(Boolean);
    let total=0;
    cards.forEach(card=>{
     const match=words.every(word=>normalize(card.dataset.catalogSearch).includes(word));
     card.hidden=!match;if(match)total++;
    });
    brands.forEach(brand=>{
     const count=Array.from(panels.get(brand).querySelectorAll('[data-catalog-search]')).filter(card=>!card.hidden).length;
     brand.hidden=count===0;
     const action=brand.querySelector('.royse-catalogos__action');
     if(words.length)action.textContent=searchInput.dataset.results.replace('{count}',count);
     else action.innerHTML=actions.get(brand);
    });
    searchBox.querySelector('[role="status"]').textContent=words.length?(total?searchInput.dataset.results.replace('{count}',total):searchInput.dataset.empty):'';
   });
  }
  const dialog=root.querySelector('dialog');
  if(!dialog||typeof dialog.showModal!=='function')return;
  root.dataset.enhanced='true';
  let active=null,opener=null,previousOverflow='';
  const body=dialog.querySelector('.royse-catalogos__dialog-body');
  root.querySelectorAll('.royse-catalogos__brand > summary').forEach(summary=>{
   summary.setAttribute('aria-haspopup','dialog');
   summary.addEventListener('click',event=>{
    event.preventDefault();
    active=summary.parentElement;opener=summary;
    const panel=active.querySelector('.royse-catalogos__panel');
    dialog.querySelector('h2').textContent=panel.dataset.brandName;
    body.append(panel);previousOverflow=document.documentElement.style.overflow;
    dialog.showModal();dialog.scrollTop=0;document.documentElement.style.overflow='hidden';
    dialog.querySelector('button').focus();
   });
  });
  dialog.querySelector('button').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{
   const panel=body.querySelector('.royse-catalogos__panel');
   if(active&&panel)active.append(panel);
   document.documentElement.style.overflow=previousOverflow;
   opener?.focus();active=null;
  });
 });
}
initRoyseCatalogs();
document.addEventListener('shopify:section:load',event=>initRoyseCatalogs(event.target));

  } catch(e) { console.error(e); }
})();
})();
